/* global StarWebPrintTrader, StarWebPrintBuilder */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import html2canvas from "html2canvas";
// Add fonts to PDF make according to the doc
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  printer: {
    printPDF: async (pdf, options = {}) => {
      /**
       * What we want to do is guess where the user is printing from and what is availabe
       * and chose the best option for printing their file
       */
      if (options.Star) {
        // Add a null check for options.host
        if (!options.host) {
          alert("No Star printer host specified.");
          return;
        }
        // For Star, just render the DOM section and send as image
        return html2canvas(document.querySelector("#section-to-print"), {
          scale: 2,
        }).then(async (canvas) => {
          const trader = new StarWebPrintTrader({
            url: `http://${options.host}/StarWebPRNT/SendMessage`,
            checkedblock: false,
          });
          const builder = new StarWebPrintBuilder();

          let request = builder.createInitializationElement();
          request += builder.createBitImageElement({
            context: canvas.getContext("2d"),
            x: 0,
            y: 0,
            width: canvas.width,
            height: canvas.height,
          });
          request += builder.createCutPaperElement({
            feed: false,
            type: "partial",
          });

          trader.onError = (response) => {
            alert("Error printing on Star Printer.", response.responseText);
          };
          return trader.sendMessage({
            request,
          });
        });
      }
      if (typeof pdf === "object") {
        // we can assume that if the pdf is an object, it is a pdfmake object so lets convert it
        // For generic browser print, open the PDF in a new window for printing
        pdfMake.createPdf(pdf).open();
      }
    },
    openDrawer: async () => {
      // Star printer logic would go here if available
      // Otherwise, just warn for now
      console.warn("openDrawer not implemented");
    },
    printToPDF: async (pdf) => {
      if (typeof pdf === "object") {
        // we can assume that if the pdf is an object, it is a pdfmake object so lets convert it
        if ((!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) && (!!window
          .navigator.standalone)) {
          alert(
            "Download not supported on this device yet when installed. Please use your browser. ",
          )
        } else {
          pdfMake.createPdf(pdf).download()
        }
      }
    },
  },
}
